import { useGET } from '../shared/hooks';

const toUrl = (seasonId, teamId, leagueId) =>
  `/stats/season/${seasonId}/team/${teamId}/combosummary?min_possessions=100&league_id=${leagueId}`;

export function useCombinationSummary(leagueId, seasonId, teamId, pathTo) {
  const url = toUrl(seasonId, teamId, leagueId);

  return useGET(url);
}
